import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "push-notification"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "push-notification__container" }
const _hoisted_4 = { class: "push-notification__text" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Ne maradj le a legfontosabb cikkekről és videókról, kapcsold be az értesítéseket! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bell = _resolveComponent("Bell")!
  const _component_Close = _resolveComponent("Close")!

  return (_ctx.isAvailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Bell, { class: "push-notification__icon" }),
              _hoisted_5
            ]),
            _createElementVNode("button", {
              class: "button button--primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activate()))
            }, " Bekapcsolom "),
            _createVNode(_component_Close, {
              class: "push-notification__close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}